import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBM0eFD4YR5nzbPAuQD07uJO5g7t1QvgCk",
  authDomain: "rosrocapdi.firebaseapp.com",
  projectId: "rosrocapdi",
  storageBucket: "rosrocapdi.firebasestorage.app",
  messagingSenderId: "225420471685",
  appId: "1:225420471685:web:9e8be8335b0d402ec5a8ec"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app); 